import React, { Component, Fragment } from 'react'
import {
  Row,
  Col,
  Collapse,
  Card,
  Icon,
  Breadcrumb,
  Divider,
  Popover,
} from 'antd'
import { Link } from 'react-router-dom'
import LangContext, { i18n } from 'modules/shared/context/langContext'

class Index extends Component {
  render() {
    const { checkMenuVisibility, web_endpoint, permissions } = this.props
    return (
      <>
        <div className="divider__web__content">
          <Divider />
        </div>

        {/* วิดีโอเรียลไทม์จาก Honey Toast */}
        {checkMenuVisibility(
          '',
          web_endpoint,
          'honeytoastlivestream',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/honeytoastlivestream">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.h.honeytoastlivestream}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          ใช้สำหรับแสดงวิดีโอ แบบเรียลไทม์
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{
                          fontSize: 'larger',
                          paddingTop: 17,
                        }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
                {/* <p className="res_text__card__web__content">
                  <span className="color__text__card__web__content">
                    <LangContext.Consumer>
                      {i18n => i18n.h.honeytoastlivestream}
                    </LangContext.Consumer>
                  </span>
                </p> */}
              </Card>
            </Link>
          </Col>
        )}
        {/* วิดีโอย้อนหลัง Honey Toast */}
        {checkMenuVisibility(
          '',
          web_endpoint,
          'honeytoastplayback',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/honeytoastplaybackwebpage">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.h.honeytoastplayback}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          ใช้สำหรับตรวจสอบวิดีโอย้อนหลัง
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{
                          fontSize: 'larger',
                          paddingTop: 17,
                        }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
                {/* <p className="res_text__card__web__content">
                  <span className="color__text__card__web__content">
                    <LangContext.Consumer>
                      {i18n => i18n.h.honeytoastplayback}
                    </LangContext.Consumer>
                  </span>
                </p> */}
              </Card>
            </Link>
          </Col>
        )}
        {/* ดาวน์โหลดวิดีโอ Honey Toast */}
        {checkMenuVisibility(
          '',
          web_endpoint,
          'honeytoastdownloadfile',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/honeytoastdownloadfilewebpage">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.h.honeytoastdownloadfile}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          ใช้สำหรับดาวน์โหลดวิดีโอ
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{
                          fontSize: 'larger',
                          paddingTop: 17,
                        }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
                {/* <p className="res_text__card__web__content">
                  <span className="color__text__card__web__content">
                    <LangContext.Consumer>
                      {i18n => i18n.h.honeytoastdownloadfile}
                    </LangContext.Consumer>
                  </span>
                </p> */}
              </Card>
            </Link>
          </Col>
        )}
      </>
    )
  }
}

export default Index
